import { NgModule } from "@angular/core";
import { ChartBarComponent } from "./shared-components/components/chart-bar/chart-bar.component";
import { ChartLineComponent } from "./shared-components/components/chart-line/chart-line.component";
import { ChartPieComponent } from "./shared-components/components/chart-pie/chart-pie.component";
import { ConfigurationSmartComponentComponent } from "./shared-components/components/configuration-smart-component/configuration-smart-component.component";
import { ContainerSmartComponentGridComponent } from "./shared-components/components/container-smart-component-grid/container-smart-component-grid.component";
import { CounterColdWaterComponent } from "./shared-components/components/counter/counter-cold-water/counter-cold-water.component";
import { CounterElectricComponent } from "./shared-components/components/counter/counter-electric/counter-electric.component";
import { CounterGasMeterComponent } from "./shared-components/components/counter/counter-gas-meter/counter-gas-meter.component";
import { CounterHeaderComponent } from "./shared-components/components/counter/counter-header/counter-header.component";
import { CounterHeatAllocatorComponent } from "./shared-components/components/counter/counter-heat-allocator/counter-heat-allocator.component";
import { CounterHeatMeterComponent } from "./shared-components/components/counter/counter-heat-meter/counter-heat-meter.component";
import { CounterHotWaterComponent } from "./shared-components/components/counter/counter-hot-water/counter-hot-water.component";
import { DraggableSliderComponent } from "./shared-components/components/draggable-slider/draggable-slider.component";
import { SmartComponentSpinnerComponent } from "./shared-components/components/smart-component-spinner/smart-component-spinner.component";
import { ThermostatExpandedSectionComponent } from "./shared-components/components/thermostat/thermostat-expanded-section/thermostat-expanded-section.component";
import { WidgetBlindComponent } from "./shared-components/components/widget-blind/widget-blind.component";
import { WidgetCounterBandTripleComponent } from "./shared-components/components/widget-counter-band-triple/widget-counter-band-triple.component";
import { WidgetCounterBandComponent } from "./shared-components/components/widget-counter-band/widget-counter-band.component";
import { WidgetCounterColdwaterComponent } from "./shared-components/components/widget-counter-coldwater/widget-counter-coldwater.component";
import { WidgetCounterDistributorComponent } from "./shared-components/components/widget-counter-distributor/widget-counter-distributor.component";
import { WidgetCounterElectricComponent } from "./shared-components/components/widget-counter-electric/widget-counter-electric.component";
import { WidgetCounterGasComponent } from "./shared-components/components/widget-counter-gas/widget-counter-gas.component";
import { WidgetCounterHeatingComponent } from "./shared-components/components/widget-counter-heating/widget-counter-heating.component";
import { WidgetCounterHotwaterComponent } from "./shared-components/components/widget-counter-hotwater/widget-counter-hotwater.component";
import { ErrorChartComponent } from "./shared-components/components/error-chart/error-chart.component";
import { SmartComponentRenderingDirectiveDirective } from "./shared-components/directives/smart-component-rendering-directive.directive";
import { WidgetCounterSkillExpandableComponent } from "./shared-components/components/widget-counter-skill-expandable/widget-counter-skill-expandable.component";
import { WidgetLightComponent } from "./shared-components/components/widget-light/widget-light.component";
import { WidgetDimmerComponent } from "./shared-components/components/widget-dimmer/widget-dimmer.component";
import { WidgetThermostatComponent } from "./shared-components/components/widget-thermostat/widget-thermostat.component";
import { WidgetAlarmComponent } from "./shared-components/components/widget-alarm/widget-alarm.component";
import { AddSmartComponentComponent } from "./shared-components/components/add-smart-component/add-smart-component.component";
import { ErrorLoadingWidgetComponent } from "./shared-components/components/error-loading-widget/error-loading-widget.component";
import { WidgetSensorComponent } from "./shared-components/components/widget-sensor/widget-sensor.component";
import { AssociateSmartComponentComponent } from "./shared-components/components/associate-smart-component/associate-smart-component.component";
import { WidgetWeatherStationComponent } from "./shared-components/components/widget-weather-station/widget-weather-station.component";
import { WidgetRoomComponent } from "./shared-components/components/widget-room/widget-room.component";
import { PopupSearchSelectComponent } from "./shared-components/components/general-components/popup-search-select/popup-search-select";
import { PopupKeywordComponent } from "./shared-components/components/general-components/popup-keyword/popup-keyword";
import { PopupRepositoryIconComponent } from "./shared-components/components/general-components/popup-repository-icon/popup-repository-icon.component";
import { WidgetLabelButtonComponent } from "./shared-components/components/widget-label-button/widget-label-button.component";
import { WidgetPageBreakComponent } from "./shared-components/components/widget-page-break/widget-page-break.component";
import { SearchAddressComponent } from "./shared-components/components/general-components/search-address/search-address.component";
import { SupervisionWidgetSettingsComponent } from "./shared-components/components/supervision-widget-settings/supervision-widget-settings.component";
import { DragAndDropFilesComponent } from "./shared-components/components/general-components/drag-and-drop-files/drag-and-drop-files.component";
import { PopupSettingsGraphicPageComponent } from "./shared-components/components/general-components/popup-settings-graphic-page/popup-settings-graphic-page";
import { PopupEnvironmentTreeComponent } from "./shared-components/components/general-components/popup-environment-tree/popup-environment-tree.component";
import { WidgetScenarioComponent } from "./shared-components/components/widget-scenario/widget-scenario.component";

/**
 * Collects the standalone components of the shared-components submodule, which no longer
 * ships its own NgModule, so the NgModule-based modules of this application can keep
 * importing them all at once.
 */
const SHARED_COMPONENTS = [
  ChartBarComponent,
  ChartLineComponent,
  ChartPieComponent,
  ConfigurationSmartComponentComponent,
  ContainerSmartComponentGridComponent,
  CounterColdWaterComponent,
  CounterElectricComponent,
  CounterGasMeterComponent,
  CounterHeaderComponent,
  CounterHeatAllocatorComponent,
  CounterHeatMeterComponent,
  CounterHotWaterComponent,
  DraggableSliderComponent,
  SmartComponentSpinnerComponent,
  ThermostatExpandedSectionComponent,
  WidgetBlindComponent,
  WidgetCounterBandTripleComponent,
  WidgetCounterBandComponent,
  WidgetCounterColdwaterComponent,
  WidgetCounterDistributorComponent,
  WidgetCounterElectricComponent,
  WidgetCounterGasComponent,
  WidgetCounterHeatingComponent,
  WidgetCounterHotwaterComponent,
  ErrorChartComponent,
  SmartComponentRenderingDirectiveDirective,
  WidgetCounterSkillExpandableComponent,
  WidgetLightComponent,
  WidgetDimmerComponent,
  WidgetThermostatComponent,
  WidgetAlarmComponent,
  AddSmartComponentComponent,
  ErrorLoadingWidgetComponent,
  WidgetSensorComponent,
  AssociateSmartComponentComponent,
  WidgetWeatherStationComponent,
  WidgetRoomComponent,
  PopupSearchSelectComponent,
  PopupKeywordComponent,
  PopupRepositoryIconComponent,
  WidgetLabelButtonComponent,
  WidgetPageBreakComponent,
  SearchAddressComponent,
  SupervisionWidgetSettingsComponent,
  DragAndDropFilesComponent,
  PopupSettingsGraphicPageComponent,
  PopupEnvironmentTreeComponent,
  WidgetScenarioComponent,
];

@NgModule({
  imports: SHARED_COMPONENTS,
  exports: SHARED_COMPONENTS,
})
export class SharedComponentsModule {}
